import FlightList from "../containers/catalogs/flight/FlightList";
import FlightForm from "../containers/catalogs/flight/FlightForm";
import FlightRouteList from "../containers/catalogs/flightRoute/FlightRouteList";
import FlightRouteForm from "../containers/catalogs/flightRoute/FlightRouteForm";

const routes = [
  {
    path: "/flights",
    component: FlightList,
  },
  {
    path: "/flights_new",
    component: FlightForm,
  },
  {
    path: "/flights/:flight_id",
    component: FlightForm,
  },
  {
    path: "/flight/:flight_id/routes",
    component: FlightRouteList,
  },
  {
    path: "/flight/:flight_id/new_route",
    component: FlightRouteForm,
  },
];

export { routes as flightRoutes };
